module.exports = "<label style=display:none><l10n>Travellers</l10n></label><div class=row><div class=col-xs-12 ng-include=\"'app/modules/base/templates/flights/form_options/travellers_dropdown.tmpl.html'\"></div></div><span></span>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/directives/templates/travellers.tmpl.html
// module id = 3694
// module chunks = 0